import React, {useCallback, useRef, useState, useEffect} from 'react';
import {APIProvider, InfoWindow, Map, MapMouseEvent} from '@vis.gl/react-google-maps';
import ClusterMarkers from './ClusterMarkers';
import MapLogicHandler from './MapLogicHandler';
import {Marker} from '../types/types';

type MapComponentProps = {
    apiKey: string;
    mapId: string;
    center: { lat: number; lng: number };
    zoom?: number;
    markers: Marker[];
    onMapClick?: (coords: { lat: number; lng: number }) => void;
    onRadiusChange?: (radiusKm: number) => void;
    sourceColors: Record<string, string>;
    CLUSTER_THRESHOLD?: number;
    shouldRecenter: boolean;
    onRecentered: () => void
    // onMarkerClick: (marker: Marker) => void
};

const MapComponent: React.FC<MapComponentProps> = ({
                                                       apiKey,
                                                       mapId,
                                                       center,
                                                       zoom = 12,
                                                       markers = [],
                                                       onMapClick,
                                                       onRadiusChange,
                                                       sourceColors,
                                                       CLUSTER_THRESHOLD = 20,
                                                       shouldRecenter,
                                                       onRecentered
                                                   }) => {
    const [selected, setSelected] = useState<Marker | null>(null);
    // const [currentZoom, setCurrentZoom] = useState<number>(zoom);
    // const [mapCenter, setMapCenter] = useState(center);
    // const mapRef = useRef<HTMLDivElement | null>(null);
    // // for nearby search
    // const lastMarkerRef = useRef<google.maps.marker.AdvancedMarkerElement | null>(null);
    // const mapInstanceRef = useRef<google.maps.Map | null>(null);

    useEffect(() => {
        console.log('🌟 selected marker changed:', selected);
    }, [selected]);

    // useEffect(() => {
    //     const map = mapInstanceRef.current;
    //     if (!map || markers.length === 0) {
    //         console.log('🌟 no map or no markers:', map, markers.length);
    //         return;
    //     }
    //     const bounds = new google.maps.LatLngBounds();
    //     markers.forEach((m) => {
    //         bounds.extend(new google.maps.LatLng(m.lat, m.lng));
    //     });
    //     console.log('🌟 bounds for markers:', bounds);
    //     map.fitBounds(bounds, {
    //         top: 50,
    //         bottom: 50,
    //         left: 50,
    //         right: 50
    //     });
    //     console.log('🌟 bounds fitted for markers:', bounds);
    // }, [markers]);

    // useEffect(() => {
    //     const map = mapInstanceRef.current;
    //     if (map && center) {
    //         console.log('📍 Center changed, panTo:', center);
    //         map.panTo(center);
    //     }
    // }, [center]);

    // const handleZoomChanged = useCallback((e: any) => {
    //     // const radius = getRadiusKmFromZoom(e.map);
    //     // console.log('[MapComponent] handleZoomChanged to get and set radius(km):', radius);
    //     const z = e.map.getZoom() ?? currentZoom;
    //     setCurrentZoom(z);
    //     setSelected(null);
    //     // onRadiusChange?.(radius);
    // }, [currentZoom]);

    const handleMapClick = (e: MapMouseEvent) => {
        const { latLng } = e.detail;
        if (!latLng) return;
        console.log('[MapComponent] handleMapClick:', latLng);
        onMapClick?.(latLng);
    };

    return (
        <APIProvider
            apiKey={apiKey}
            libraries={['marker', 'geometry']}
        >
            <Map
                mapId={mapId}
                defaultCenter={center}
                defaultZoom={zoom}
                style={{width: '100%', height: '100vh'}}
                scrollwheel={true}
                zoomControl={true}
                // onZoomChanged={handleZoomChanged}
                onClick={handleMapClick}
                // onCameraChanged={(e) => {
                //     const { center: newCenter } = e.detail;
                //     if (newCenter && typeof google !== 'undefined' && google.maps?.geometry?.spherical) {
                //         const distance = google.maps.geometry.spherical.computeDistanceBetween(
                //             new google.maps.LatLng(center),
                //             new google.maps.LatLng(newCenter)
                //         ) / 1000;
                //         console.log('[MapComponent] onCameraChanged to get and set distance(km):', distance);
                //         if (!isNaN(distance) && distance > 0.1) {
                //             onRadiusChange?.(Math.round(distance));
                //         } else {
                //             console.warn('🟡 radius calculation skipped due to invalid or too small value:', distance);
                //         }
                //     }
                // }}
            >
                <ClusterMarkers
                    markers={markers}
                    sourceColors={sourceColors}
                    onMarkerClick={setSelected}
                    CLUSTER_THRESHOLD={CLUSTER_THRESHOLD}
                />
                {selected && (
                    <InfoWindow
                        position={{lat: selected.lat, lng: selected.lng}}
                        onCloseClick={() => setSelected(null)}
                        pixelOffset={[0, -25]}
                    >
                        <div className="card" style={{minWidth: '250px'}}>
                            <div className="card-body">
                                <h5 className="card-title">{selected.name ?? 'No name'}</h5>
                                <h6 className="text-muted mb-1">{selected.source ?? 'no source'}</h6>
                                <p className="text-muted mb-2">{selected.address ?? 'No address'}</p>
                                {/*{selected.evConnectors && Object.entries(selected.evConnectors).map(([key, conn]) => (*/}
                                {/*        console.log("[1]>>>>>>>>>>>>>", conn.type),*/}
                                {/*            console.log("[2]>>>>>>>>>>>>>", key),*/}
                                {/*            console.log("[3]>>>>>>>>>>>>>", typeof(conn.connectorDetails)),*/}
                                {/*            <div key={key}>*/}
                                {/*                <h6>{key} （{conn.type}）</h6>*/}
                                {/*                {conn.connectorDetails && Object.entries(conn.connectorDetails).map(([key, detail]) => (*/}
                                {/*                    console.log("[4]>>>>>>>>>>>>>", key),*/}
                                {/*                    <div key={key}>*/}
                                {/*                        {detail.maxChargeRateKw.toFixed(1)} kW — {detail.availableCount}/{detail.count}*/}
                                {/*                    </div>*/}
                                {/*                ))}*/}
                                {/*            </div>*/}
                                {/*    ))*/}
                                {/*}*/}

                                {selected.evConnectors &&
                                    Object.values(selected.evConnectors).flatMap((conn, i) =>
                                        <div
                                            key={i}
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ fontSize: '0.95rem' }}>
                                            <div className="d-flex align-items-center">
                                                <span style={{color: '#007bff', fontSize: '1.1rem', marginRight: 6}}>⚡</span>
                                                <span>{conn.type}</span>
                                                <span className="mx-1">·</span>
                                                <span>{conn.maxChargeRateKw.toFixed(2)} kW</span>
                                            </div>
                                            <div className="text-end text-muted" style={{ minWidth: 40 }}>
                                                {conn.availableCount}/{conn.count}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </InfoWindow>
                )}
                <MapLogicHandler markers={ markers } center={ center } shouldRecenter={ shouldRecenter } onRecentered={ onRecentered } />
            </Map>
        </APIProvider>
    );
};

export default MapComponent;
